<template>
    <div>
        <v-row no-gutters align="center">
            <v-col cols="6">
                <modal-cadu :close="true" @input="$emit('input', false)" :width="620" :value="value">
                    <div slot="all" class="py-12 px-10">
                        <div slot="body">
                            <v-row no-gutters>
                                <v-col cols="12" align="center" class="mb-6">
                                    <div class="font-secundaria font-weight-bold headline fontColor--text">
                                        Deseja cancelar as atualizações realizadas?
                                    </div>
                                </v-col>
                                <v-col cols="6" align="center">
                                    <div>
                                        <button-cadu
                                            text="Não"
                                            @click="$emit('input', false)"
                                            outline
                                        />
                                    </div>
                                </v-col>
                                <v-col cols="6" align="center">
                                    <div>
                                        <button-cadu
                                            text="Sim"
                                            @click="cancelarEdicao()"
                                            :backColor="$vuetify.theme.themes.light.primary1"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </modal-cadu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      valueData: this.value,
      iconStyle: {
        color: this.$vuetify.theme.themes.light.primary1
      }
    }
  },
  methods: {
    cancelarEdicao () {
      this.$emit('cancelar-edicao')
      this.valueData = false
    }
  }
}
</script>
